import AuthChecker from "./AuthChecker";
import AuthPrivateRoute from "./AuthPrivateRoute";
import AuthRedirect from "./AuthRedirect";

export default {
  Checker: AuthChecker,
  Redirect: AuthRedirect,
  PrivateRoute: AuthPrivateRoute,
};
